export class ProviderCard {
  id: number
  name: string
  pictureUrl?: string
  cntBenefits: number
  discountPercentage: number
}
